import * as z from "zod/v4";

export const DEFAULT_SHOPPER_AGENT_PERSONA_NAME = "Jessica";

export const ShopperAgentPersonaConfigSchema = z.object({
  name: z.string().optional(),
});

export type ShopperAgentPersonaConfig = z.infer<
  typeof ShopperAgentPersonaConfigSchema
>;

/**
 * Resolves the persona name the agent should use when speaking to a customer.
 * Falls back to {@link DEFAULT_SHOPPER_AGENT_PERSONA_NAME} when the team has
 * no persona configured or has cleared the name. All read sites should go
 * through this helper so the default is enforced in one place.
 */
export function getPersonaName(
  config: { name?: string | null } | null | undefined,
): string {
  return config?.name?.trim() || DEFAULT_SHOPPER_AGENT_PERSONA_NAME;
}
